import { adminApiFetch } from './apiService';

export const unknownProductService = {
  getRecords: async (params) => {
    const response = await adminApiFetch('unknown_products/get_records', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  },
  getIds: async (params) => {
    const response = await adminApiFetch('unknown_products/get_ids', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  },
  get: async (id) => {
    const response = await adminApiFetch(`unknown_products/${id}`);
    return response.json();
  },
  mapTo: async (unknownProductId, productId, { backfillToPlatform = false } = {}) => {
    const response = await adminApiFetch(`unknown_products/${unknownProductId}/map_to`, {
      method: 'PUT',
      body: JSON.stringify({
        product_id: productId,
        backfill_to_platform: backfillToPlatform
      })
    });
    return response.json();
  },
};
